// context/AuthContext.js
import React, { createContext, useState, useContext, useEffect } from 'react';

const AuthContext = createContext({});

export const useAuth = () => useContext(AuthContext);

const decodeJWT = (token) => {
  if (!token) return null;
  
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    return JSON.parse(jsonPayload);
  } catch (e) {
    console.error('Error decoding JWT:', e);
    return null;
  }
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [isLoading, setIsLoading] = useState(true); // Changed from 'loading' to 'isLoading'

  useEffect(() => {
    console.log('AuthProvider: Checking localStorage for auth data');
    const storedToken = localStorage.getItem('token');
    const storedUser = localStorage.getItem('user');
    
    console.log('Stored token exists:', !!storedToken);
    console.log('Stored user exists:', !!storedUser);
    
    if (storedToken && storedUser) {
      try {
        const parsedUser = JSON.parse(storedUser);
        console.log('Parsed user from localStorage:', parsedUser);
        
        // Verify the token is still valid (optional)
        const decodedToken = decodeJWT(storedToken);
        console.log('Decoded token from localStorage:', decodedToken);
        
        if (decodedToken) {
          setToken(storedToken);
          setUser(parsedUser);
        } else {
          // Token is invalid, clear storage
          console.log('Token invalid, clearing storage');
          localStorage.removeItem('token');
          localStorage.removeItem('user');
        }
      } catch (error) {
        console.error('Error parsing stored user:', error);
        localStorage.removeItem('token');
        localStorage.removeItem('user');
      }
    } else {
      console.log('No stored auth data found');
    }
    
    setIsLoading(false);
  }, []);

  const login = async (username, password) => {
    try {
      const API_BASE_URL = process.env.REACT_APP_API_ENTRYPOINT || 'http://localhost:8085/kzc';
      console.log('AuthContext: Making login request to:', `${API_BASE_URL}/api/auth/login`);
      
      const response = await fetch(`${API_BASE_URL}/api/auth/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ userName: username, password }),
      });

      console.log('AuthContext: Response status:', response.status);

      if (!response.ok) {
        const errorText = await response.text();
        console.log('AuthContext: Error response:', errorText);
        return { success: false, error: 'Invalid credentials' };
      }

      const data = await response.json();
      console.log('AuthContext: Login success data:', data);

      // Decode JWT to get user ID
      const decodedToken = decodeJWT(data.token);
      console.log('AuthContext: Decoded JWT:', decodedToken);
      
      // Extract user ID from JWT (try different possible field names)
      const userId = decodedToken?.userId || decodedToken?.id || decodedToken?.user?.id || data.id;
      console.log('AuthContext: Extracted user ID:', userId);

      // Create user object
      const userObj = {
        id: userId,
        username: data.username || username,
        role: data.role || 'USER'
      };

      // Store in localStorage
      localStorage.setItem('token', data.token);
      localStorage.setItem('user', JSON.stringify(userObj));

      // Update state
      setToken(data.token);
      setUser(userObj);

      return { success: true, data: userObj };

    } catch (error) {
      console.error('AuthContext: Login error:', error);
      return { success: false, error: 'Network error' };
    }
  };

  const logout = () => {
    console.log('AuthContext: Logging out');
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setToken(null);
    setUser(null);
  };

  const isAuthenticated = () => {
    return !!token;
  };

  const hasRole = (role) => {
    return user?.role === role;
  };

  const getAuthHeader = () => {
    return token ? { 'Authorization': `Bearer ${token}` } : {};
  };

  // Function to get user ID (useful for other components)
  const getUserId = () => {
    return user?.id;
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        token,
        isLoading, // Changed from 'loading' to 'isLoading'
        login,
        logout,
        isAuthenticated,
        hasRole,
        getAuthHeader,
        getUserId 
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};






// import React, { createContext, useState, useContext, useEffect } from 'react';

// const AuthContext = createContext({});

// export const useAuth = () => useContext(AuthContext);

// const decodeJWT = (token) => {
//   if (!token) return null;
  
//   try {
//     const base64Url = token.split('.')[1];
//     const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
//     const jsonPayload = decodeURIComponent(
//       atob(base64)
//         .split('')
//         .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
//         .join('')
//     );
//     return JSON.parse(jsonPayload);
//   } catch (e) {
//     console.error('Error decoding JWT:', e);
//     return null;
//   }
// };

// export const AuthProvider = ({ children }) => {
//   const [user, setUser] = useState(null);
//   const [token, setToken] = useState(null);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const token = localStorage.getItem('token');
//     const user = localStorage.getItem('user');
    
//     if (token && user) {
//       setToken(token);
//       setUser(JSON.parse(user));
//     }
    
//     setLoading(false);
//   }, []);

//   const login = async (username, password) => {
//     try {
//       const API_BASE_URL = process.env.REACT_APP_API_ENTRYPOINT || 'http://localhost:8085/kzc';
//       console.log('AuthContext: Making login request to:', `${API_BASE_URL}/api/auth/login`);
      
//       const response = await fetch(`${API_BASE_URL}/api/auth/login`, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({ userName: username, password }),
//       });

//       console.log('AuthContext: Response status:', response.status);

//       if (!response.ok) {
//         const errorText = await response.text();
//         console.log('AuthContext: Error response:', errorText);
//         return { success: false, error: 'Invalid credentials' };
//       }

//       const data = await response.json();
//       console.log('AuthContext: Login success data:', data);

//       // Decode JWT to get user ID
//       const decodedToken = decodeJWT(data.token);
//       console.log('AuthContext: Decoded JWT:', decodedToken);
      
//       // Extract user ID from JWT (try different possible field names)
//       const userId = decodedToken?.userId || decodedToken?.id || decodedToken?.user?.id;
//       console.log('AuthContext: Extracted user ID:', userId);

//       // Store in localStorage
//       localStorage.setItem('token', data.token);
//       localStorage.setItem('user', JSON.stringify({
//         id: userId, // Now we have the ID!
//         username: data.username,
//         role: data.role
//       }));

//       // Update state
//       setToken(data.token);
//       setUser({
//         id: userId,
//         username: data.username,
//         role: data.role
//       });

//       return { success: true, data };

//     } catch (error) {
//       console.error('AuthContext: Login error:', error);
//       return { success: false, error: 'Network error' };
//     }
//   };

//   const logout = () => {
//     localStorage.removeItem('token');
//     localStorage.removeItem('user');
//     setToken(null);
//     setUser(null);
//   };

//   const isAuthenticated = () => {
//     return !!token;
//   };

//   const hasRole = (role) => {
//     return user?.role === role;
//   };

//   const getAuthHeader = () => {
//     return token ? { 'Authorization': `Bearer ${token}` } : {};
//   };

//   // Function to get user ID (useful for other components)
//   const getUserId = () => {
//     return user?.id;
//   };

//   return (
//     <AuthContext.Provider
//       value={{
//         user,
//         token,
//         loading,
//         login,
//         logout,
//         isAuthenticated,
//         hasRole,
//         getAuthHeader,
//         getUserId 
//       }}
//     >
//       {children}
//     </AuthContext.Provider>
//   );
// };